<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Billing Expense Details </b-navbar-brand>
        </b-navbar>

        <b-card class="formCard mb-2" v-if="getSingleExpenseDeatils">
          <b-card-text>
            <div>
              <b-row class="mt-3">
                <b-col>
                  <h5 class="mt-4">
                    <b-badge variant="info">Assignment Details : </b-badge>
                  </h5>
                  <p style="margin-bottom: 0px">
                    Assignment No :
                    <span
                      ><b> {{ getSingleExpenseDeatils.AssNo }}</b></span
                    >
                  </p>

                  <p style="margin-bottom: 0px">
                    Assignment Date :<span
                      ><b> {{ getSingleExpenseDeatils.AssDate }}</b></span
                    >
                  </p>
                  <p style="margin-bottom: 0px">
                    MBLNO :<span
                      ><b> {{ getSingleExpenseDeatils.MBLNO }}</b></span
                    >
                  </p>
                  <p style="margin-bottom: 0px">
                    HBLNO :<span
                      ><b> {{ getSingleExpenseDeatils.HBLNO }}</b></span
                    >
                  </p>
                  <p style="margin-bottom: 0px">
                    Sline :<span
                      ><b> {{ getSingleExpenseDeatils.shippingLine }}</b></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Client Name :
                    <span
                      ><b>{{ getSingleExpenseDeatils.clientName }}</b></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Location :<br />
                    <span
                      >POR : <b> {{ getSingleExpenseDeatils.POR }}</b></span
                    ><br />
                    <span
                      >POL : <b> {{ getSingleExpenseDeatils.POL }}</b></span
                    ><br />
                    <span
                      >POD : <b> {{ getSingleExpenseDeatils.POD }}</b></span
                    ><br />
                    <span
                      >FPOD : <b> {{ getSingleExpenseDeatils.FPOD }}</b></span
                    ><br />
                  </p>
                  <br
                /></b-col>
                <b-col>
                  <h5 class="mt-4">
                    <b-badge variant="info">Expense Details : </b-badge>
                  </h5>
                  <p style="margin-bottom: 0px">
                    Expense Type:
                    <span
                      ><b>{{ getSingleExpenseDeatils.docDtls_Typ }}</b></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Expense No:
                    <span
                      ><b>
                        <u
                          ><a
                            style="color: blue"
                            v-if="getSingleExpenseDeatils.docDtls_No"
                            :href="
                              `${docURL}/ASSIGNMENT_UPLOADS/Common_Invoices_doc/` +
                              getSingleExpenseDeatils.docDtls_No.replaceAll('/', '_') +
                              '.pdf'
                            "
                            target="_blank"
                            download
                            >{{ getSingleExpenseDeatils.docDtls_No }}</a
                          ></u
                        ></b
                      ></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Expense Price:
                    <span
                      ><b>{{ getSingleExpenseDeatils.TotInvVal }}</b></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Expense Date :
                    <span
                      ><b> {{ getSingleExpenseDeatils.Exp_Date }}</b></span
                    >
                  </p>
                  <br
                /></b-col>
                <b-col>
                  <h5 class="mt-4">
                    <b-badge variant="info">Buyer Details : </b-badge>
                  </h5>
                  <p style="margin-bottom: 0px">
                    Buyer Name :
                    <span
                      ><b> {{ getSingleExpenseDeatils.buyerName }}</b></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Buyer GST :
                    <span
                      ><b> {{ getSingleExpenseDeatils.buyerGST }}</b></span
                    >
                  </p>
                  <br />

                  <p style="margin-bottom: 0px">
                    Buyer Add :
                    <span
                      ><b> {{ getSingleExpenseDeatils.buyerAdd }}</b></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Buyer State :
                    <span
                      ><b> {{ getSingleExpenseDeatils.buyerState }}</b></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Buyer State Code :
                    <span
                      ><b> {{ getSingleExpenseDeatils.buyerStateCode }}</b></span
                    >
                  </p>
                  <br />
                </b-col>
              </b-row>
              <b-row class="mt-3">
                <b-col>
                  <h5 class="mt-4">
                    <b-badge variant="info">Vendor Details : </b-badge>
                  </h5>
                  <p style="margin-bottom: 0px">
                    Vendor Name :
                    <span
                      ><b> {{ getSingleExpenseDeatils.vendorName }}</b></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Vendor GST :
                    <span
                      ><b> {{ getSingleExpenseDeatils.vendorGST }}</b></span
                    >
                  </p>
                  <br />

                  <p style="margin-bottom: 0px">
                    Vendor State/Code :
                    <span
                      ><b>
                        {{ getSingleExpenseDeatils.vendorState }} /
                        {{ getSingleExpenseDeatils.vendorStateCode }}</b
                      ></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Vendor Addr/Pin :
                    <span
                      ><b> {{ getSingleExpenseDeatils.vendorAdd }}</b></span
                    >
                  </p>
                  <br />
                </b-col>

                <b-col>
                  <h5 class="mt-4">
                    <b-badge variant="info">Shipper Details : </b-badge>
                  </h5>
                  <p style="margin-bottom: 0px">
                    Shipper GST :
                    <span
                      ><b> {{ getSingleExpenseDeatils.shipDtls_Gstin }}</b></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Shipper Name :
                    <span
                      ><b> {{ getSingleExpenseDeatils.shipDtls_LglNm }}</b></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Shipper Addr/Pin :
                    <span
                      ><b>
                        {{ getSingleExpenseDeatils.shipDtls_Addr1 }} /
                        {{ getSingleExpenseDeatils.shipDtls_Pin }}</b
                      ></span
                    >
                  </p>
                  <br />
                </b-col>
                <b-col>
                  <h5 class="mt-4">
                    <b-badge variant="info">Others Details : </b-badge>
                  </h5>
                  <p style="margin-bottom: 0px">
                    INV No :
                    <span
                      ><b> {{ getSingleExpenseDeatils.invoice_No_Date }}</b></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Shipper Bill No :
                    <span
                      ><b> {{ getSingleExpenseDeatils.sBNO_BENo_Date }}</b></span
                    >
                  </p>
                  <br />
                  <p style="margin-bottom: 0px">
                    Weight :
                    <span
                      ><b>{{ getSingleExpenseDeatils.weight_CBM }}</b></span
                    >
                  </p>
                  <br />
                </b-col>
              </b-row>
            </div>
            <br />

            <h5 class="mt-4 mb-2">
              <b-badge variant="info">Container Details : </b-badge>
            </h5>
            <b-row>
              <p style="margin-bottom: 0px">
                Conatiner :
                <span
                  ><b>{{ getSingleExpenseDeatils.ExpContainersNo }}</b></span
                >
              </p>
              <br />
              <p style="margin-bottom: 0px">
                Sys Conatiner :
                <span
                  ><b>{{ getSingleExpenseDeatils.AssContainerNos }}</b></span
                >
              </p>
              <br />
              <p style="margin-bottom: 0px">
                Sys Container Type :
                <span
                  ><b>{{ getSingleExpenseDeatils.containerType }}</b></span
                >
              </p>
              <br />
            </b-row>

            <div class="box-body gutr mt-4">
              <table id="tpt" class="table table-bordered">
                <thead>
                  <tr>
                    <th>SN.</th>
                    <th>Particulars</th>
                    <th>Split Status</th>
                    <th>Quantity</th>
                    <th>Barcode</th>
                    <th>HSNCode</th>
                    <th>Amount</th>
                    <th>GST Rate</th>
                    <th>IGST Amt</th>
                    <th>CGST Amt</th>
                    <th>SGST Amt</th>
                    <th>Cest Rt/Amt</th>

                    <th>Amt</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item1, index) in ExpenseItemDeatils" :key="index">
                    <td>{{ index + 1 }}</td>

                    <td>{{ item1.prdDesc }}
                      
                
                    </td>
                    <td><b-button
                      v-if="item1.SplitStatus=='YES'"
                    @click="
                      showExpenseDet(
                        item1,
                        'Expense',
                        2,
                        getSingleExpenseDeatils.docDtls_No,
                        getSingleExpenseDeatils.AssNo,
                        'Exp'
                      )
                    "
                    variant="outline-info"
                    size="xs"
                    style="font-size: 0.675rem"
                    class="mt-1"
                    >{{ item1.SplitStatus }}</b-button></a>
                    <b v-else >{{ item1.SplitStatus }}</b></td>
                    <td>{{ item1.qty }}</td>
                    <td>{{ item1.barcde }}</td>
                    <td>{{ item1.hsnCd }}</td>
                    <td>
                      {{ item1.totAmt }}
                    </td>
                    <td>{{ item1.gstRt }}</td>
                    <td>
                      {{ item1.igstAmt }}
                    </td>
                    <td>{{ item1.cgstAmt }}</td>
                    <td>{{ item1.sgstAmt }}</td>
                    <td>{{ item1.cesRt }} / {{ item1.cesAmt }}</td>
                    <td>{{ item1.assAmt }}</td>
                    <td>{{ item1.totItemVal }} {{ item1.orgCntry }}</td>
                  </tr>
                </tbody>
              </table>
              <br />
              <div>
                <b>Amount + Tax = Total Amount </b>
                <br />
                <b
                  >{{ getSingleExpenseDeatils.AMT }} + {{ taxAmount }} =
                  {{ getSingleExpenseDeatils.TotInvVal }}
                </b>
              </div>
            </div>

            <b-modal
              id="otherTallyExpCharges-modal"
              ref="otherTallyExpCharges-modal"
              :title="modal_title + modal_JobNo"
              size="xl"
              no-close-on-esc
              no-close-on-backdrop
              hide-footer
            >
              <div class="row">
                <div class="col-md-12 row">
                  <div class="col-md-12">
                    <table id="tpt" class="table table-bordered">
                      <thead>
                        <tr>
                          <th>SN.</th>
                          <th>Particulars</th>
                          <th>Quantity</th>
                          <th>Barcode</th>
                          <th>HSNCode</th>
                          <th>Amount</th>
                          <th>GST Rate</th>
                          <th>IGST Amt</th>
                          <th>CGST Amt</th>
                          <th>SGST Amt</th>
                          <th>Cest Rt/Amt</th>

                          <th>Amt</th>
                          <th>Total</th>
                          <th>JOB</th>
                          <th>JOB AMT</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item1, index) in ExpenseItemSplitList" :key="index">
                          <td>{{ index + 1 }}</td>

                          <td>{{ item1.PrdDesc }}</td>
                          <td>{{ item1.Qty }}</td>
                          <td>{{ item1.Barcde }}</td>
                          <td>{{ item1.HsnCd }}</td>
                          <td>
                            {{ item1.TotAmt }}
                          </td>
                          <td>{{ item1.GstRt }}</td>
                          <td>
                            {{ item1.IgstAmt }}
                          </td>
                          <td>{{ item1.CgstAmt }}</td>
                          <td>{{ item1.SgstAmt }}</td>
                          <td>{{ item1.CesRt }} / {{ item1.CesAmt }}</td>
                          <td>{{ item1.AssAmt }}</td>
                          <td>{{ item1.TotItemVal }} {{ item1.OrgCntry }}</td>
                          <td>{{ item1.JOBNO }}</td>
                          <td>{{ item1.JOBAMT }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <!-- <br />
                    <div>
                      <b>Amount + Tax = Total Amount </b>
                      <br />
                      <b
                        >{{ singleItem.AMT }} + {{ taxAmount }} =
                        {{ singleItem.TotInvVal }}
                      </b>
                    </div> -->
                  </div>
                  <div class="col-md-12 text-center">
                    <center>
                      <b-button
                        @click="hideExpenseDet"
                        style="font-size: 11px"
                        size="sm"
                        class="mt-1"
                        variant="danger"
                      >
                        Close</b-button
                      >
                    </center>
                  </div>
                </div>
              </div>
            </b-modal>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert
      :md-content="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
export default {
  beforeMount() {
    if (globalPermissionStatus("Accounts")) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/freightInvoiceForTally");
      this.getSingleExpenseList();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },
  data() {
    return {
      ExpenseItemDeatils: [],
      getSingleExpenseDeatils: "",
      Filter: {
        tally_bill_exp_id: 0,
        fk_all_module_id: 0,
      },
      taxAmount: 0,
      containerDetails: [],
      getSingleExpenseDeatils: {},
      getSingleExpenseDeatilsItem: [],
      docURL: URL_BASE_DOC,
      isLoading: false,
      alert: {
        content: "Added Succesfully",
        ok: "ok",
      },
      ExpenseItemSplitList:[],
      Mtitle:"",
      modal_title:"",
      modal_JobNo:"",
      singleItem:{},
    };
  },

  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    CustomLoader,
  },
  watch: {
    deep: true,
  },
  computed: {},
  methods: {
    hideExpenseDet() {
      this.Mtitle = "";
      this.singleItem = "";
      this.ExpenseItemSplitList = [];
      this.taxAmount = 0;
      this.$refs["otherTallyExpCharges-modal"].hide();
    },
    showExpenseDet(item, title, type, invNo, jobNo, typeCode) {
      console.log("item=>", item);
      this.Mtitle = "";
      this.Mtitle = title;
      this.singleItem = item;
      this.ExpenseItemSplitList = [];
      this.getSingleExpenseItemSpiltList(item);
      this.modal_title =
        title + " Item List - " + typeCode + " No-" + invNo + " Charge - "+item.prdDesc;
      this.modal_JobNo = jobNo;
      this.$refs["otherTallyExpCharges-modal"].show();
    },

     getSingleExpenseItemSpiltList(item) {
      this.ExpenseItemSplitList = [];
   
      this.isLoading = true;
      let payload = {
        itemCode: "getExpenseItemSplitList",
        fk_tally_bill_exp_id: this.$sessionsStorage.get("tallyExpenseId"),
        fk_all_module_id: this.$sessionsStorage.get("tallyExpenseallModuleID"),
        fk_tally_bill_exp_item_id: item.tbei_id,
      };
      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            console.log(" ExpenseItemSplitList response=>", data);
            if (data.ExpenseItemSplitList) {
              this.ExpenseItemSplitList = data.ExpenseItemSplitList;
            }
          } else {
            this.ExpenseItemSplitList = [];
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getAllExpenseList Error: ", error);
        });
    },

    getSingleExpenseList() {
      (this.Filter = {
        tally_bill_exp_id: this.$sessionsStorage.get("tallyExpenseId"),
        fk_all_module_id: this.$sessionsStorage.get("tallyExpenseallModuleID"),
      }),
        (this.isLoading = true);
      let payload = {
        itemCode: "getSingleExpenseDeatils",
        Filter: this.Filter,
      };
      CommonService.getAllExpenseList(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            console.log(" getAllExpenseList response=>", data);
            if (data.getSingleExpenseDeatils) {
              this.ExpenseItemDeatils = data.ExpenseItemDeatils;
              this.getSingleExpenseDeatils = data.getSingleExpenseDeatils;
              console.log(" getAllExpenseList response=>", data);
              this.taxAmount =
                parseFloat(this.getSingleExpenseDeatils.CGST) +
                parseFloat(this.getSingleExpenseDeatils.SGST) +
                parseFloat(this.getSingleExpenseDeatils.IGST) +
                parseFloat(this.getSingleExpenseDeatils.CesVal) +
                parseFloat(this.getSingleExpenseDeatils.StCesVal) +
                parseFloat(this.getSingleExpenseDeatils.RndOffAmt) +
                parseFloat(this.getSingleExpenseDeatils.OthChrg) -
                parseFloat(this.getSingleExpenseDeatils.Discount);
            }
          } else {
            this.getSingleExpenseDeatils = [];
            this.ExpenseItemDeatils = [];
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getAllExpenseList Error: ", error);
        });
    },
    getGRNpdf(item) {
      window.open(`${this.docURL}/` + item);
    },
    previousSalesView() {
      window.history.go(-1);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// tallyExpDetails.vue?2f344f2f